/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const SORTABLE_LIST_STRINGS = {
  dragHandle: 'Drag handle for item',
  dragToChangeOrder: 'Drag this item to change the order',
  pressSpaceToLift: 'Press space bar to lift the item',
  reorder: 'Reorder',
};

export enum SortableListStyle {
  Default = `default`,
  GreyBox = `grey-box`,
}
